import { filter } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { appConfigsApi } from 'api';
import { QueryKey, AppConfigKey, AppConfigArea, P2PProviderType } from 'enums';
import { AppConfig } from 'types';
import { p2pProviderUtils } from 'utils';

export const useP2PProvidersConfig = () => {
  const { data, isLoading } = useQuery(QueryKey.Configs, () =>
    appConfigsApi.getForAreaPaginated(AppConfigArea.P2PProvidersCommon)(),
  );
  const availableP2PProviderTypes = useMemo(() => {
    const defaultP2PProviderTypes = [P2PProviderType.InternalLike];
    return (
      data?.items?.find(
        (schema: AppConfig) =>
          schema.key === AppConfigKey.AvailableP2PProviderTypes,
      )?.jsonArrayValue || defaultP2PProviderTypes
    );
  }, [data]);
  const availableP2PProviderTypeOptions = useMemo(
    () =>
      filter(p2pProviderUtils.typeOptions, (item) =>
        availableP2PProviderTypes.includes(item.value),
      ),
    [availableP2PProviderTypes],
  );

  const isP2PProviderAvailable = (providerType?: P2PProviderType) =>
    availableP2PProviderTypes.includes(providerType);

  return {
    availableP2PProviderTypeOptions,
    isP2PProviderAvailable,
    isLoading,
  };
};
